import { useState } from 'react';
import { IconUpgrade } from '../Icons';

export default function EngineUpgradeBadge({ engineVersion }: { engineVersion: number | null }) {
  const [open, setOpen] = useState(false);
  const label = engineVersion ? `Upgraded to engine version ${engineVersion}` : 'Engine upgrade';

  return (
    <span className="vt-badge-wrap">
      <button
        type="button"
        className="vt-badge"
        title={label}
        aria-label={label}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <IconUpgrade size={14} />
      </button>
      {open && (
        <>
          <div className="vt-menu-backdrop" onClick={() => setOpen(false)} />
          <div className="vt-badge-popover" role="tooltip">
            {label}
          </div>
        </>
      )}
    </span>
  );
}
